import { render, staticRenderFns } from "./InvalidCredentials.vue?vue&type=template&id=6b6a2c3b&scoped=true&"
import script from "./InvalidCredentials.vue?vue&type=script&lang=js&"
export * from "./InvalidCredentials.vue?vue&type=script&lang=js&"
import style0 from "./InvalidCredentials.vue?vue&type=style&index=0&id=6b6a2c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a2c3b",
  null
  
)

export default component.exports